import TrainerSingleBaseLayout from './TrainerSingleBaseLayout';

const defaultProps = {};

const propTypes = {};

export default function TrainerSingleLayout({ sidebar, children }) {
  return (
    <TrainerSingleBaseLayout>
      <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-16 relative z-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">{sidebar}</div>
        </div>
        <div className="lg:col-span-8 lg:pr-10">{children}</div>
      </div>
    </TrainerSingleBaseLayout>
  );
}

TrainerSingleLayout.defaultProps = defaultProps;
TrainerSingleLayout.propTypes = propTypes;
